module.exports = __webpack_public_path__ + "static/img/fuselage_899.23ebbec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/fuselage_899.jpg
// module id = YYpV
// module chunks = 0